import { useSelector } from '@/libs/state'
import { sheetStack$, openSheet, closeSheet, getSheetEntityId } from '../store'
import type { SheetId } from '../domain/ui'

const GLOBAL_SHEET_IDS = {
	CUSTOMER_CREATE: 'customer-create',
	CUSTOMER_EDIT: 'customer-edit',
	MEMBER_CREATE: 'member-create',
	MEMBER_DETAILS: 'member-details',
	MEMBER_EDIT: 'member-edit',
} as const

const useSheet = (id: SheetId) => {
	const isOpen = useSelector(() => sheetStack$.get().some(s => s.id === id))
	const entityId = useSelector(() => getSheetEntityId(id))

	return {
		isOpen,
		entityId,
		open: (entityId?: string) => openSheet(id, entityId ?? null),
		close: () => closeSheet(id),
	}
}

export { useSheet, GLOBAL_SHEET_IDS }
